var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['switchbar',_vm.zhuangtai?'':'nocheckbox'],on:{"click":_vm.SetSwitch}},[_c('div',{class:['switchbutton',_vm.zhuangtai?'':'nocheck']})])}
var staticRenderFns = []

export { render, staticRenderFns }